import { mapGetters, mapActions, mapMutations } from 'vuex'
import States from '@/helper/States'

export default {
  data () {
    return {
      city: '',
      uf: '',
      pagination: {},
      states: States,
      headers: [
        { text: 'Habilitar', align: 'left', sortable: false },
        { text: 'Descrição', align: 'left', sortable: false },
        { text: 'Ações', align: 'center', sortable: false }
      ],
      rowsPerPage: [10, 20, 30],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterCityRisks',
      'getterSelectedCityRisk'
    ])
  },
  watch: {
    pagination: {
      handler () {
        this.getAllCityRisks()
      },
      deep: true
    }
  },
  mounted () {
    this.getAllCityRisks()
  },
  beforeDestroy () {
    this.CLEAR_CITY_RISK_STORE()
  },
  methods: {
    ...mapActions([
      'actionGetAllCityRisks',
      'actionAddCityRisk',
      'actionEditCityRisk'
    ]),
    ...mapMutations([
      'SET_SELECTED_CITY_RISK',
      'CLEAR_CITY_RISK_STORE'
    ]),
    setSelectedCityRisk (item) {
      this.SET_SELECTED_CITY_RISK(item)
      this.city = item.cidadeOriginal || item.cidade
      this.uf = item.uf
    },
    getAllCityRisks () {
      const params = {
        idClient: this.getterAccount.idClient,
        page: (this.pagination && this.pagination.page) ? this.pagination.page : 1,
        limit: this.pagination.rowsPerPage || this.rowsPerPage[0]
      }

      this.isLoading = true

      this.actionGetAllCityRisks(params)
        .then(() => {
          this.pagination.totalItems = this.getterCityRisks.totalResults

          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    onClickMainButton () {
      if (Object.keys(this.getterSelectedCityRisk).length === 0) {
        this.addCityRisk()
      } else {
        this.editCityRisk()
      }
    },
    addCityRisk () {
      const item = {
        idClient: this.getterAccount.idClient,
        cidade: this.city,
        uf: this.uf,
        active: true
      }

      this.isLoading = true

      this.actionAddCityRisk(item)
        .then(() => {
          this.cleanForm()

          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    editCityRisk (item) {
      let updatedItem = {}
      const data = {
        cidade: this.city,
        cidadeOriginal: this.city,
        uf: this.uf
      }

      if (item) {
        updatedItem = {
          ...data,
          ...item
        }
      } else {
        updatedItem = {
          ...this.getterSelectedCityRisk,
          ...data
        }
      }

      this.isLoading = true

      this.actionEditCityRisk(updatedItem)
        .then(() => {
          this.cleanForm()

          this.isLoading = false
        })
        .catch(() => {
          this.cleanForm()

          this.isLoading = false
        })
    },
    cleanForm () {
      this.city = this.uf = ''
      this.SET_SELECTED_CITY_RISK()
    }
  }
}
